import axios from "axios";
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';


export const resetPasswordRequest = () => ({
    type: RESET_PASSWORD_REQUEST
});

export const resetPasswordSuccess = () => ({
    type: RESET_PASSWORD_SUCCESS
});

export const resetPasswordFailure = (error) => ({
    type: RESET_PASSWORD_FAILURE,
    payload: error
});

export const resetPassword = (formData, token) => async (dispatch) => {
    dispatch(resetPasswordRequest());
    try {
        const formDataToSend = {
            currentPassKey: formData.temporaryPassword,
            newPassKey: formData.newPassword,
            reNewPassKey: formData.confirmNewPassword
        };
        const url = `${process.env.REACT_APP_API_URL}/resetPassword?passwordToken=${token}`;
        const response = await axios.post(url, formDataToSend, {
            headers: { 'Content-Type': 'application/json' }
        });
        if (response.status === 200) {
            dispatch(resetPasswordSuccess());
        }
    } catch (error) {
        const errorMessage = error.response?.data?.message || "Something went wrong";
        dispatch(resetPasswordFailure(errorMessage));
    }
};
